/*
 * Description of what this file is for
 *
 * @package  baukasten
 * @author Stefan Prosch [hello@stefanprosch.com]
 * pageTitle
 */

import fitty from 'fitty';

const pageTitle = {
    cfg:  {
        name: 'pageTitle',
        elements: [...document.querySelectorAll('.js-pageTitle')],
        fitties: [],
        fittyOptions: {
            minSize: 12,
            maxSize: 300,
            observeWindow: true,
        },
    },

    initText() {
        this.cfg.fitties = fitty('.js-pageTitle');

        /* this.cfg.elements.forEach((item) => {
            fitty(item, this.cfg.fittyOptions);
        });

        this.resizeText(); */

        this.cfg.fitties.forEach((fit) => {
            fit.fit();
        });

        this.resizeText();
    },

    getStyle(el, cssprop) {
        if (el.currentStyle) { // IE & Opera
            return el.currentStyle[cssprop];
        } else if (document.defaultView && document.defaultView.getComputedStyle) { // Gecko & WebKit
            return document.defaultView.getComputedStyle(el, '')[cssprop];
        }
    },

    resizeText() {
        // this.cfg.fitties.fitAll();

        /* this.cfg.elements.forEach((item) => {
            const fontSize = 12; // this.getStyle(item, 'fontSize');
            item.setAttribute('style',`line-height:${fontSize}px`);
        }); */
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.elements.length > 0) {
                this.initText();
                // this.resizeText();
            }
        });

        window.addEventListener('resize', () => {
            if (this.cfg.elements.length > 0) {
                this.resizeText();
            }
        });
    }
};

export default pageTitle;



// WEBPACK FOOTER //
// ./___src/templates/_molecules/pageTitle/_script.js